import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { AppShell } from '@/layouts/AppShell'
import { LanguageProvider, buildLangPath, langFromPath, readStoredLang } from '@/i18n'

const HomePage = lazy(() => import('@/pages/HomePage').then((m) => ({ default: m.HomePage })))
const ExplorePage = lazy(() => import('@/pages/ExplorePage').then((m) => ({ default: m.ExplorePage })))
const StatusPage = lazy(() => import('@/pages/StatusPage').then((m) => ({ default: m.StatusPage })))
const TechniquePage = lazy(() => import('@/pages/TechniquePage').then((m) => ({ default: m.TechniquePage })))
const AttackChainsPage = lazy(() => import('@/pages/AttackChainsPage').then((m) => ({ default: m.AttackChainsPage })))
const AttackChainDetailPage = lazy(() =>
  import('@/pages/AttackChainDetailPage').then((m) => ({ default: m.AttackChainDetailPage })),
)
const ToolsPage = lazy(() => import('@/pages/ToolsPage').then((m) => ({ default: m.ToolsPage })))
const ToolDetailPage = lazy(() => import('@/pages/ToolDetailPage').then((m) => ({ default: m.ToolDetailPage })))

function Fallback() {
  return <div className="zone-content" style={{ padding: 24 }}>Loading...</div>
}

function RootRedirect() {
  const stored = readStoredLang() || 'de'
  return <Navigate to={buildLangPath(stored, '/')} replace />
}

function CatchAll() {
  const location = useLocation()
  const stored = readStoredLang() || 'de'
  const existing = langFromPath(location.pathname)
  if (existing) return <Navigate to={buildLangPath(existing, '/')} replace />
  return <Navigate to={buildLangPath(stored, '/')} replace />
}

function langBranch(lang: 'de' | 'en') {
  return (
    <Route path={"/" + lang} element={<AppShell />}>
      <Route index element={<HomePage />} />
      <Route path="explore" element={<ExplorePage />} />
      <Route path="status" element={<StatusPage />} />
      <Route path="attack-chains" element={<AttackChainsPage />} />
      <Route path="attack-chains/:slug" element={<AttackChainDetailPage />} />
      <Route path="tools" element={<ToolsPage />} />
      <Route path="tools/:slug" element={<ToolDetailPage />} />
      <Route path=":category/:slug" element={<TechniquePage />} />
    </Route>
  )
}

export default function App() {
  return (
    <LanguageProvider>
      <Suspense fallback={<Fallback />}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          {langBranch('de')}
          {langBranch('en')}
          <Route path="*" element={<CatchAll />} />
        </Routes>
      </Suspense>
    </LanguageProvider>
  )
}
